<!-- Custom items in the user's dropdown -->
<ng-template #navbarUserDropdownContent>
    <div class="dropdown-divider"></div>
    <h6 class="dropdown-header">Submit Data</h6>
    <button ngbDropdownItem routerLink="/organisations/new" class="dropdown-item">New Organisation</button>
    <button ngbDropdownItem routerLink="/projects/new" class="dropdown-item">New Project</button>
    <button ngbDropdownItem routerLink="/sites/new" class="dropdown-item">New Site</button>
  </ng-template>

<main-layout [sidebarLayout]="sidebarLayout" site="restorer" [navbarUserDropdownContent]="navbarUserDropdownContent">
	<router-outlet></router-outlet>

    <ng-template #sidebarContent>
        <div class="sidebar-endorsements">
            <h3>Endorsed By</h3>
            <img src="/assets/images/logos/endorsing-partners/un-decade.jpg">
            <img src="/assets/images/logos/endorsing-partners/ser.png">
            <img src="/assets/images/logos/endorsing-partners/wsa.png">
        </div>
    </ng-template>
</main-layout>